module.exports = __webpack_public_path__ + "static/media/shield.efbc419e.svg";